
import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import Service from "./service/Service";
import Make from "./vehicleDetail/Make";
import Model from "./vehicleDetail/Model";
import FuelType from "./vehicleDetail/Fuel_type";
import SubServiceType from "./service/Sub_Service_type";
import SelectTheme from "./SelectTheme";
import WorkshopOnboard from "./workshop/WorkshopOnboard";
import ListedWorkshops from "./workshop/ListedWorkshops";
import WorkshopInfo from "./workshop/WorkshopInfo";
import WorkshopEdit from "./workshop/WorkshopEdit";
import Consent from "./consent/Consent";
import Feedback from "../inventory/feedback/Feedback";
import ERCSConfiguration from "../inventory/configuration/ERCSConfiguration";
import Policy from "../inventory/policy/Policy";
import Banner from "./banner/Banner";
import Appointment from "./Appointment/Appointment";
import GetAppintmentDetails from "./Appointment/GetAppintmentDetails";
import PendingAppointment from "./PendingAppointment/PendingAppointment";
import LeadGeneration from "./Leads/LeadGeneration";
import Faq from "./Faq/Faq";
import Gallery from './gallery/Gallery'

interface IPROPS {
  setLiftingName: any;
}

const Index: React.FC<IPROPS> = ({ setLiftingName }) => {
  return (
    <Routes>
      <Route
        path="/make"
        element={
          <>
            <Make setLiftingName={setLiftingName} />
          </>
        }
      />
      <Route
        path="/model"
        element={
          <>
            <Model setLiftingName={setLiftingName} />
          </>
        }
      />
      <Route
        path="/fuel_type"
        element={
          <>
            <FuelType setLiftingName={setLiftingName} />
          </>
        }
      />
      <Route
        path="/service-type"
        element={
          <>
            <Service setLiftingName={setLiftingName} />
          </>
        }
      />

      <Route
        path="/sub_service-type"
        element={
          <>
            <SubServiceType setLiftingName={setLiftingName} />
          </>
        }
      />

      <Route
        path="/workshop-onboard"
        element={
          <>
            <WorkshopOnboard />
          </>
        }
      />

      <Route
        path="/workshop-listed"
        element={
          <>
            <ListedWorkshops />
          </>
        }
      />
      <Route
        path="/workshop-listed/:id"
        element={
          <>
            <WorkshopInfo />
          </>
        }
      />

      <Route
        path="/workshop-edit/:id"
        element={
          <>
            <WorkshopEdit />
          </>
        }
      />

      <Route
        path="/theme"
        element={
          <>
            <SelectTheme />
          </>
        }
      />

      <Route
        path="/consent"
        element={
          <>
            <Consent />
          </>
        }
      />

      <Route
        path="/feedback"
        element={
          <>
            <Feedback />
          </>
        }
      />

      <Route
        path="/appointment-confirmed"
        element={
          <>
            <Appointment />
          </>
        }
      />
      <Route
        path="/appointment-pending"
        element={
          <>
            <PendingAppointment />
          </>
        }
      />
      <Route
        path="/Appointment/*"
        element={
          <>
            <GetAppintmentDetails />
          </>
        }
      />
      <Route
        path="/configuration"
        element={
          <>
            <ERCSConfiguration />
          </>
        }
      />

      <Route
        path="/policy"
        element={
          <>
            <Policy />
          </>
        }
      />

      <Route
        path="/banner"
        element={
          <>
            <Banner />
          </>
        }
      />

      <Route
        path="/faq"
        element={
          <>
            <Faq />
          </>
        }
      />


      <Route
        path="/lead-generation"
        element={
          <>
            <LeadGeneration />
          </>
        }
      />
      <Route
                path='/gallery'
                element={
                    <>
                        <Gallery />
                    </>
                }
            />
    </Routes>
  );
};

export default Index;
